import { render, staticRenderFns } from "./DomainRegistrationPricing.vue?vue&type=template&id=25108009&"
import script from "./DomainRegistrationPricing.vue?vue&type=script&lang=js&"
export * from "./DomainRegistrationPricing.vue?vue&type=script&lang=js&"
import style0 from "./DomainRegistrationPricing.vue?vue&type=style&index=0&id=25108009&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports